let initialState = {
  loader: false,
};

const CommandCenter = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_COMMAND_CENTER":
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default CommandCenter;
